import { Button, Dropdown, Input, InputGroup, Stack } from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import CloseIcon from '@rsuite/icons/Close';
import { useEffect, useState } from 'react';
import { t } from 'i18next';
import { useAppSelector } from '@monorepo/shared';
import { selectHaCurrentGroup } from '@monorepo/shared/store/groupSlice';

interface IGroupProps {
  setGroupSearchObj: any;
}
export const GroupSearch = ({ setGroupSearchObj }: IGroupProps) => {
  const currentHaGroup = useAppSelector(selectHaCurrentGroup);
  const searchItems = [
    {
      name: 'account_id',
      title: `${t('common.orgSearch.accountID')}`
    },
    { name: 'account_company', title: `${t('common.orgSearch.company')}` },
    { name: 'master_user_name', title: `${t('common.orgSearch.owner')}` }
  ];
  const [searchKey, setSearchKey] = useState<string>(searchItems[0]?.name);
  const [searchVal, setSearchVal] = useState<string>('');
  const [count, setCount] = useState<number>(0);
  const [searchIdx, setSearchIdx] = useState<number>(0);
  const submitSearch = async () => {
    if (searchKey) {
      setCount(count + 1);
      setGroupSearchObj({
        key: searchKey,
        value: searchVal,
        clickBtnNum: count + 1
      });
    }
  };

  const clearSearch = async () => {
    if (searchVal) {
      setSearchVal('');
      setCount(count + 1);
      setGroupSearchObj({
        key: searchKey,
        value: '',
        clickBtnNum: count + 1
      });
    }
  };
  useEffect(() => {
    setCount(0);
    setSearchVal('');
  }, [currentHaGroup?.id]);

  return (
    <Stack spacing={6}>
      <Stack.Item flex={1}>
        <InputGroup inside className="group-search-inside">
          <Dropdown title={searchItems[searchIdx]?.title} size="sm">
            {searchItems.map((obj: Record<string, string>, index: number) => (
              <Dropdown.Item
                key={index}
                onSelect={() => {
                  setSearchKey(obj?.name);
                  setSearchIdx(index);
                }}
              >
                {obj?.title}
              </Dropdown.Item>
            ))}
          </Dropdown>
          <Input
            className="search-input"
            value={searchVal}
            onChange={setSearchVal}
            onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) => {
              if (e.key == 'Enter') {
                submitSearch();
              }
            }}
          />
          <InputGroup.Button onClick={clearSearch}>
            <CloseIcon color="var(--light-blue)" />
          </InputGroup.Button>
        </InputGroup>
      </Stack.Item>
      <Button appearance="primary" size="sm" onClick={submitSearch}>{`${t(
        'common.servicePanel.search'
      )}`}</Button>
    </Stack>
  );
};
